import React from "react";
import { Link } from "react-router-dom";
import DRLogo from "../../assets/img/DR-Insurance-Logo.svg";

const Header = () => {
  return (
    <>
      <header className="header">
        <div className="container">
          <Link to="/">
            <img src={DRLogo} alt="DR logo" />
          </Link>
        </div>
      </header>
    </>
  );
};

export default Header;
